/**
 * Events log service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditLogRecordDto { 
    id?: number;
    createdAt?: Date;
    ip?: string;
    requestPath?: string;
    requestMethod?: string;
    userFirstName?: string;
    userMiddleName?: string;
    userLastName?: string;
    userId?: number;
    description?: string;
    summary?: string;
    isAdministrationAction?: boolean;
    portalDeterminate?: AuditLogRecordDto.PortalDeterminateEnum;
    profileType?: AuditLogRecordDto.ProfileTypeEnum;
    methodArguments?: { [key: string]: any; };
    device?: string;
    screenResolution?: string;
    browser?: string;
    latitude?: number;
    longitude?: number;
    city?: string;
}
export namespace AuditLogRecordDto {
    export type PortalDeterminateEnum = 'COMMON';
    export const PortalDeterminateEnum = {
        COMMON: 'COMMON' as PortalDeterminateEnum
    };
    export type ProfileTypeEnum = 'COMMON_BUYER' | 'COMMON_SELLER' | 'LEGAL_BUYER' | 'LEGAL_SELLER' | 'OPERATOR' | 'COMMON_AGENT' | 'LEGAL_AGENT' | 'UNKNOWN' | 'MODERATOR' | 'TECHNICAL_USER' | 'COURIER';
    export const ProfileTypeEnum = {
        COMMON_BUYER: 'COMMON_BUYER' as ProfileTypeEnum,
        COMMON_SELLER: 'COMMON_SELLER' as ProfileTypeEnum,
        LEGAL_BUYER: 'LEGAL_BUYER' as ProfileTypeEnum,
        LEGAL_SELLER: 'LEGAL_SELLER' as ProfileTypeEnum,
        OPERATOR: 'OPERATOR' as ProfileTypeEnum,
        COMMON_AGENT: 'COMMON_AGENT' as ProfileTypeEnum,
        LEGAL_AGENT: 'LEGAL_AGENT' as ProfileTypeEnum,
        UNKNOWN: 'UNKNOWN' as ProfileTypeEnum,
        MODERATOR: 'MODERATOR' as ProfileTypeEnum,
        TECHNICAL_USER: 'TECHNICAL_USER' as ProfileTypeEnum,
        COURIER: 'COURIER' as ProfileTypeEnum
    };
}


